export type IconName =
  | 'home'
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-forward'
  | 'arrow-back'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'open-in-new'
  | 'download'
  | 'logout'
  | 'checklist'
  | 'mail'
  | 'edit'
  | 'sign-language'
  | 'easy-language'
  | 'autorenew'
  | 'add'
  | 'close'
  | 'delete'
  | 'search'
  | 'question-mark'
  | 'more-vert'
  | 'content-copy'
  | 'visibility'
  | 'visibility-off'
  | 'check'
  | 'drive-folder-upload'
  | 'chevron-left'
  | 'chevron-right'
  | 'keyboard-double-arrow-left'
  | 'keyboard-double-arrow-right'
  | 'plus'
  | 'check-circle'
  | 'close-circle'
  | 'pause'
  | 'play'
  | 'refresh'
  | 'folder'
  | 'account'
  | 'email'
  | 'send'
  | 'source-branch'
  | 'link'
  | 'content-save'
  | 'clipboard-text'
  | 'chart-bar'
  | 'information'
  | 'alert'
  | 'magnify'
  | 'key';

export type IconSize = 'small' | 'default' | 'large' | 'x-large' | 'medium';

export interface IconProps {
  name: IconName;
  size?: IconSize;
  className?: string;
}

/**
 * KERN Icon Component
 *
 * Usage:
 * <Icon name="home" />
 * <Icon name="edit" size="large" />
 * <Icon name="delete" size="small" />
 */
export function Icon({ name, size = 'default', className = '' }: IconProps) {
  const sizeClass = size !== 'default' ? `kern-icon--${size}` : '';

  const classes = ['kern-icon', `kern-icon--${name}`, sizeClass, className]
    .filter(Boolean)
    .join(' ');

  return <span className={classes} aria-hidden="true" />;
}

export default Icon;
